import React from 'react';
import { Alert, Slide } from '@mui/material';
import { useOfflineStatus } from '../../hooks/useOfflineStatus';

const OfflineIndicator: React.FC = () => {
  const isOffline = useOfflineStatus();

  return (
    <Slide direction="down" in={isOffline} mountOnEnter unmountOnExit>
      <Alert 
        severity="warning" 
        sx={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          zIndex: 1300,
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
            textAlign: 'center'
          }
        }}
      >
        You're currently offline. Some features may not be available.
      </Alert>
    </Slide>
  );
};

export default OfflineIndicator;